<template>
  <div>
    <center>
      <h1 class="animated fadeIn white--text">Litt om meg selv</h1>
      <h3 class="grey--text animated flipInX slow">
        <strong class="animated fadeIn slow delay-1s">K</strong>ristian
        <strong class="animated fadeIn delay-2s">L</strong>avik
        <strong class="animated fadeIn delay-3s">S</strong>olbakken
      </h3>
      <hr style="max-width:50%;" class="ma-2" />
    </center>
    <v-row>
      <v-col>
        <v-card class="pa-2">
          <center>
            <h1>Hva jeg liker å gjøre på</h1>
          </center>
        </v-card>
        <v-row>
          <v-col>
            <MoreDetails
              title="Basketball"
              imageUrl="https://cdn.clipart.email/5e8d41e275a1692996cc219c54921721_basketball-black-slam-dunk-basketball-transparent-background-png-_600-599.jpeg"
            />
          </v-col>
          <v-col>
            <MoreDetails title="Lage musikk" imageUrl="https://lh3.googleusercontent.com/BpUuORXh0V6Y2FDOr5SOiTj5PvoWndvYudpeZ5N5KgWJQg9MQg24JZ8fWGPnEgNw4c134YnbIcOL_NQ4_vU10VZJ_IZTuhznQR4OJm-CKp0xTU2PgmOtnS3BEtfvKT074-unJtjzzTN4fla85JOqgASTxZmm_sEJ2RPHwf7lvv48t3bFCu8f2gOOEN1_SSPtBB-Zcz7kbfW-J2xqg5TI71e3DUp_GKc-GUsRL7VpQ6Yw0ZlF2EBJv-fnYHI4ezWWwEuHu_8gmtFlxGypOe--q_3OZqQkZnvzAaHQJ-iWxH6YK7EIteHoRzecrospjAPYCzCI5KB7zrNkyMj_CxU3NRuThwyJedNYaBxaMgaeW7D-e7UnloZ2Az48Q4UprilI9HTb_GbWoT3pdAhUBhDgfa7P4yzL_kZiCK_yHIwBMgDuZSYc6lWFoQZuSQlSdAfVQ5mDCsrDiZLIBjkMqYH391O87JQURRoxZYd02saq_l6FC6rEObSvrmgyHpodz4nMWuq2sokixM6mdsfKeRtd4pfJN-xc419jgikTvU-BmmQunrw90sPcKDTS8wxHZ_atVpMQUu6kPCTgQkGB9D1FSRCFGjucKAsl1rzK5m-7IEKtL8KdNXn7P-x6CSFA5rQDCPAugexQogp3EZivzgw1DmLIfJrkqxZKhrvSIPswrWN440-kzPQSZHpaHPJR=w1647-h926-no">
              <h2>En kjapp 'ting' jeg lagde mens jeg var i Oslo for Experis Academy.</h2>
              <p>Det varier ofte hva jeg lager, og i eksempelet under var jeg hindret av den bærbare maskinen som kun klarte å håndtere 4 "tracks" før den krasjet. Da ble det en funky bassline med noen 'percussion' elementer</p>
              <video height="400vh" controls>
                <source src="@/assets/videos/jam_from_oslo.mp4" type="video/mp4" />
              </video>
              <p class="title mt-4">Jeg har holdt på med elektronisk musikk i ca. 3-4 år nå.</p>
            </MoreDetails>
          </v-col>

          <v-col>
            <MoreDetails title="Programmere" />
          </v-col>

          <v-col>
            <MoreDetails title="Saksofon" description="Spilt 10 år" />
          </v-col>

          <v-col>
            <MoreDetails title="Lese" description="Både faglige og andre bøker" />
          </v-col>
          <v-col>
            <MoreDetails
              title="Være i aktivitet"
              description="Mine hobbyer gjør at jeg sitter mye i ro, så det er viktig å passe på helsen."
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="3"></v-col>
      <v-col>
        <v-card class="pa-5">
          <h1 class="mb-4">Litt om meg selv</h1>

          <p class="title">Jeg liker å ta på meg nye utfordringer og lære av erfaringene.</p>
          <p>Mens jeg jobbet som en IKT-medarbeider fikk jeg et sterkt innsyn i hva som forventes av hver enkelt person i en hektisk og krevende jobb.</p>
          <p>
            Samtidig som jeg jobbet som en IKT-medarbeider opparbeidet jeg erfaring på fritiden med diverse 'freelance' prosjekter.
            Dette har ført til mange spennende og lærerike prosjekter og hele {{yearsOfProgramming}} år med programmering.
            Kompetansen jeg har opparbeidet på denne tiden har vært svært nyttig, og det er alltid noe jeg har funnet meg selv jeg kan bli bedre på.
          </p>
          <p>I tillegg til alt det tekniske man må kunne så mener jeg det er minst like viktig å være pålitelig og pliktoppfyllende.</p>
        </v-card>
        <v-col>
          <v-card class="pa-4">
            <v-icon>fas fa-quote-right</v-icon>
            <center>
              <p
                class="grey--text mt-8 title"
              >Putt in en kul quote her</p>
            </center>

            <p class="text-right">
              <v-icon>fas fa-quote-right</v-icon>
            </p>
          </v-card>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MoreDetails from "@/components/MoreDetails";
export default {
  components: { MoreDetails },

  beforeMount() {
    const today = new Date();

    const yearStarted = 2015;
    this.yearsOfProgramming = today.getFullYear() - yearStarted;
  },

  data() {
    return {
      yearsOfProgramming: 0
    };
  }
};
</script>

<style>
</style>